import { EventOnChildrenDirective } from './directives/event-on-children.directive';
import { ObserveResizeDirective } from './directives/observe-resize.directive';
import { getHTMLStringAsTextPipe } from './pipes/get-html-as-string.pipe';
import { CommentsContainerComponent } from '@frontend/unhideschool/shared/components/comments/comments-container/comments-container.component';
import { ClearPasteFormatingDirective } from './directives/clear-formating.directive';
import { ClickedOutDirective } from './directives/clickedout.directive';
import { SafeImage } from './pipes/safe-image.pipe';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, SlicePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ButtonContainerComponent } from './components/button-container/button-container.component';
import { MainNavContainerComponent } from './components/main-nav-container/main-nav-container.component';
import { NavItemDividerComponent } from '../core/components/nav-item-divider/nav-item-divider.component';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { SpinnerLoaderComponent } from './components/spinner-loader/spinner-loader.component';
import { IfMediaDirective } from './directives/if-media.directive';
import { SimpleTabsComponent } from './components/simple-tabs/simple-tabs.component';
import { SimpleTabsTabComponent } from './components/simple-tabs-tab/simple-tabs-tab.component';
import { VideoBoxComponent } from './components/video-box/video-box.component';
import { BannerHighlightComponent } from './components/banner-highlight/banner-highlight.component';
import { BannersHomeComponent } from './components/banners-home/banners-home.component';
import { BannerDefaultComponent } from './components/banner-default/banner-default.component';
import { BannerProComponent } from './components/banner-pro/banner-pro.component';
import { BannersPromoComponent } from './components/banners-promo/banners-promo.component';
import { ButtonComponent } from './components/button/button.component';
import { StudentsPortfolioComponent } from './components/students-portfolio/students-portfolio.component';
import { ImgLoadedDirective } from './directives/img-loaded.directive';
import { DropdownListComponent } from './components/dropdown-list/dropdown-list.component';
import { DropdownListItemComponent } from './components/dropwdown-list-item/dropdown-list-item.component';
import { ListItemComponent } from './components/list-item/list-item.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { InputGroupComponent } from './components/input-group/input-group.component';
import { DropdownButtonComponent } from './components/dropdown-button/dropdown-button.component';
import { MaterialModule } from '../material/material.module';

import { ModalComponent } from './components/modal/modal.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { DateFnsFormatPipe } from './pipes/moment-format.pipe';
import { BackgroundfyPipe } from './pipes/backgroundfy.pipe';
import { GenericRowContainerComponent } from './components/generic-row-container/generic-row-container.component';
import { GenericGalleryComponent } from './components/generic-gallery/generic-gallery.component';
import { GenericGalleryItemComponent } from './components/generic-gallery-item/generic-gallery-item.component';
import { SimpleGalleryItemComponent } from './components/simple-gallery-item/simple-gallery-item.component';
import { ObserveOffsetBottomDirective } from './directives/observe-offset-bottom.directive';
import { InputAcessorDirective } from './directives/input-acessor.directive';
import { TextareaAcessorDirective } from './directives/textarea-acessor.directive';
import { DownloadResourceDirective } from './directives/download-resource';
import { GenericGalleryAdminToolbarComponent } from './components/generic-gallery-admin-toolbar/generic-gallery-admin-toolbar.component';
import { QuickActionsContainerComponent } from './components/quick-actions-container/quick-actions-container.component';
import { HoverObserverDirective } from './directives/hover-observer.directive';
import { QuickActionsItemComponent } from './components/quick-actions-item/quick-actions-item.component';
import { GalleryItemCropDialog } from './dialogs/gallery-item-crop/gallery-item-crop.dialog';

import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageCropperContainerComponent } from './components/image-cropper-container/image-cropper-container.component';
import { AddClassOnClickDirective } from './directives/add-class-on-click.directive';
import { MenuStateObserverDirective } from './directives/menu-state-observer';

import { ProjectHighlightComponent } from './components/project-highlight/project-highlight.component';
import { ProjectItemComponent } from './components/project-item/project-item.component';
import { SwiperModule } from 'ngx-swiper-wrapper';

import { UserActionsComponent } from './components/user-actions/user-actions.component';
import { QuillContentRendererComponent } from './components/quill-content-renderer/quill-content-renderer.component';
import { DateFnsFormatTimePipe } from './pipes/moment-format-time.pipe';
import { SumPropertyPipe } from './pipes/sum-property.pipe';
import { InterpolateStringPipe } from './pipes/interpolate-string.pipe';
import { CompareDatePipe } from './pipes/compare-date.pipe';
import { GenericSwiperSliderComponent } from './components/generic-swiper-slider/generic-swiper-slider.component';
import { BounceOnClickDirective } from './directives/bounce-on-click.directive';
import { FocusOnNextFormElement } from './directives/focus-next-form-element.directive';
import { AnimatedLikeButtonComponent } from './components/svg-animations/animated-like-button/animated-like-button.component';
import { SliderVideosComponent } from './components/slider-videos/slider-videos.component';
import { PaymentModule } from '../modules/payment/payment.module';

import {
  GenericContentContainerComponent,
  SlotLeftComponent,
  SlotMiddleComponent,
  SlotRightComponent,
} from './components/generic-content-container/generic-content-container.component';

import { PriceBoxComponent } from './components/price-box/price-box.component';
import { PriceBoxBordlessComponent } from './components/price-box-bordless/price-box-bordless.component';
import { PriceBoxSimpleComponent } from './components/price-box-simple/price-box-simple.component';
import { PriceBoxTeamComponent } from './components/price-box-team/price-box-team.component';
import { TestimonialBoxComponent } from './components/testimonial-box/testimonial-box.component';
import { RatingComponent } from './components/rating/rating.component';
import { CompareGridComponent } from './components/compare-grid/compare-grid.component';
import { StickyItemDirective } from './directives/sticky-item.directive';
import { UnhDialogRefDirective } from './directives/dialog/dialog-conatiner-ref.directive';
import { CustomCropperButton } from './directives/cropper-custom-button.directive';

import { FaqComponent } from './components/faq/faq.component';
import { PriceWithDiscountComponent } from './components/price-with-discount/price-with-discount.component';
import { PaymentProfileCardComponent } from './components/payment-profile-card/payment-profile-card.component';
import { SimpleCardComponent } from './components/simple-card/simple-card.component';
import { SocialMenuComponent } from '../core/components/social-menu/social-menu.component';
import { MosaicoItemComponent } from './components/mosaico-item/mosaico-item.component';
import { MosaicoItemSquareComponent } from './components/mosaico-item/mosaico-item-square/mosaico-item-square.component';
import { MosaicoItemSuperTrunfoComponent } from './components/mosaico-item/mosaico-item-super-trunfo/mosaico-item-super-trunfo.component';
import { MosaicoProjetosComponent } from './components/mosaico-projetos/mosaico-projetos.component';
import { DepoimentosItemComponent } from './components/depoimentos-item/depoimentos-item.component';
import { DepoimentosContainerComponent } from './components/depoimentos-container/depoimentos-container.component';
import { CommaJoinedTagsComponent } from './components/comma-joined-tags/comma-joined-tags.component';
import { SpinnerProgressComponent } from './components/spinner-progress/spinner-progress.component';
import { ArrayJoinPipe } from './pipes/array-join.pipe';
import { KeysMapperPipe } from './pipes/keys-mapper.pipe';
import { IsProductOwnedPipe } from './pipes/is-product-owned.pipe';
import { FormCreditCardComponent } from './components/form-credit-card/form-credit-card.component';
import { RetryPaymentDialog } from './dialogs/payment/payment-retry.dialog';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { BenefitsPanelComponent } from './components/benefits-panel/benefits-panel.component';
import { ResponsiveVideoComponent } from './components/responsive-video/responsive-video.component';
import { SectionTitleComponent } from './components/section-title/section-title.component';
import { FilterProjectGridComponent } from './components/filter-project-grid/filter-project-grid.component';
import { FilterProjectGridItemComponent } from './components/filter-project-grid-item/filter-project-grid-item.component';
import { GenericComponentsModule } from './generic-components/generic-components.module';
import { ConfirmationComponent } from './dialogs/confirmation/confirmation.component';
import { LoadingComponent } from './dialogs/loading/loading.component';
import { QuillModule } from 'ngx-quill';
import { EmbedVideo } from 'ngx-embed-video';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { StripHtmlPipe } from './pipes/strip-html';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { MediaUploaderModule } from '@frontend/media-uploader';
import { CommentItemComponent } from './components/comments/comment-item/comment-item.component';
import { CommentBoxReplyComponent } from './components/comments/comment-box-reply/comment-box-reply.component';
import { LoaderPackComponent } from './components/loader-pack/loader-pack.component';
import { SlugifyPipe } from './pipes/slugify.pipe';
import { ParseJsonPipe } from './pipes/parse.json.pipe';
import { DialogNavigationComponent } from './components/dialog-navigation/dialog-navigation.component';
import { BlocksControlsContainerComponent } from './components/blocks-controls-container/blocks-controls-container.component';
import { PromoTagComponent } from './components/promo-tag/promo-tag.component';
import { OldPriceTagComponent } from './components/old-price-tag/old-price-tag.component';
import { CommentQuillEditorComponent } from './components/comments/comment-quill-editor/comment-quill-editor.component';
import { PostBadgesListComponent } from '@frontend/unhideschool/modules/forum/components/post-badges-list/post-badges-list.component';
import { InViewportModule } from '@thisissoon/angular-inviewport';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { UnhBottomsheetComponent } from './bottomsheets/unhbottomsheet/unhbottomsheet.component';
import { FakeProjectPostItem } from './components/fake-project-post-item/fake-project-post-item';
import { CustomToolbarComponent } from './components/custom-toolbar/custom-toolbar.component';
import { CookieDialogComponent } from './dialogs/cookie-dialog/cookie-dialog.component';
import { CustomPromoTagComponent } from './components/custom-promo-tag/custom-promo-tag.component';
import { ModalxContainerComponent } from './dialogs/modalx/modalx.component';
import { TransformImagePipe } from './pipes/transform-image.pipe';
import { ConfirmDefaultComponent } from './dialogs/confirm-default/confirm-default.component';
import { UserAvatarModule } from './components/user-avatar/user-avatar.module';
import { EllipsisPipe } from './pipes/slice.pipe';

import { FilterBottomsheetOptionListComponent } from './components/filter-bottomsheet-option-list/filter-bottomsheet-option-list.component';
import { ProjectListComponent } from './components/project-list/project-list.component';
import { FilterBottomsheetHeaderComponent } from './components/filter-bottomsheet-header/filter-bottomsheet-header.component';
import { FilterBottomsheetComponent } from './components/filter-bottomsheet/filter-bottomsheet.component';
import { CoursesNotFoundComponent } from './components/courses-not-found/courses-not-found.component';
import { BannerBirthdayComponent } from './components/banner-birthday/banner-birthday.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    ButtonContainerComponent,
    MainNavContainerComponent,
    NavItemDividerComponent,
    SvgIconComponent,
    SpinnerLoaderComponent,
    SimpleTabsComponent,
    SimpleTabsTabComponent,
    VideoBoxComponent,
    BannerHighlightComponent,
    BannersHomeComponent,
    BannersPromoComponent,
    BannerDefaultComponent,
    BannerProComponent,
    ButtonComponent,
    StudentsPortfolioComponent,
    DropdownListComponent,
    DropdownListItemComponent,
    ListItemComponent,
    SearchInputComponent,
    InputGroupComponent,
    DropdownButtonComponent,
    ModalComponent,
    GenericRowContainerComponent,
    GenericGalleryComponent,
    GenericGalleryAdminToolbarComponent,
    GenericGalleryItemComponent,
    SimpleGalleryItemComponent,
    QuickActionsContainerComponent,
    QuickActionsItemComponent,
    ImageCropperContainerComponent,
    DateFnsFormatPipe,
    DateFnsFormatTimePipe,
    StripHtmlPipe,
    IfMediaDirective,
    ImgLoadedDirective,
    ObserveOffsetBottomDirective,
    DownloadResourceDirective,
    HoverObserverDirective,
    GalleryItemCropDialog,
    RetryPaymentDialog,
    AddClassOnClickDirective,
    MenuStateObserverDirective,
    ProjectHighlightComponent,
    ProjectItemComponent,
    UserActionsComponent,
    QuillContentRendererComponent,
    SumPropertyPipe,
    CompareDatePipe,
    DateAgoPipe,
    GenericSwiperSliderComponent,
    BounceOnClickDirective,
    AnimatedLikeButtonComponent,
    GenericContentContainerComponent,
    SlotLeftComponent,
    SlotMiddleComponent,
    SlotRightComponent,
    PriceBoxComponent,
    PriceBoxSimpleComponent,
    PriceBoxBordlessComponent,
    PriceBoxTeamComponent,
    TestimonialBoxComponent,
    RatingComponent,
    CompareGridComponent,
    StickyItemDirective,
    FaqComponent,
    PriceWithDiscountComponent,
    PaymentProfileCardComponent,
    SimpleCardComponent,
    SocialMenuComponent,
    MosaicoItemComponent,
    MosaicoItemSquareComponent,
    MosaicoItemSuperTrunfoComponent,
    MosaicoProjetosComponent,
    DepoimentosItemComponent,
    DepoimentosContainerComponent,
    SliderVideosComponent,
    CommaJoinedTagsComponent,
    SpinnerProgressComponent,
    ArrayJoinPipe,
    KeysMapperPipe,
    IsProductOwnedPipe,
    FormCreditCardComponent,
    BenefitsPanelComponent,
    ResponsiveVideoComponent,
    SectionTitleComponent,
    FilterProjectGridComponent,
    FilterProjectGridItemComponent,
    ConfirmationComponent,
    LoadingComponent,
    CommentItemComponent,
    CommentBoxReplyComponent,
    LoaderPackComponent,
    SlugifyPipe,
    ParseJsonPipe,
    SafeImage,
    getHTMLStringAsTextPipe,
    DialogNavigationComponent,
    ClickedOutDirective,
    BlocksControlsContainerComponent,
    ClearPasteFormatingDirective,
    PromoTagComponent,
    OldPriceTagComponent,
    CommentsContainerComponent,
    CommentQuillEditorComponent,
    PostBadgesListComponent,
    DropdownComponent,
    EventOnChildrenDirective,
    UnhBottomsheetComponent,
    CustomToolbarComponent,
    FakeProjectPostItem,
    ObserveResizeDirective,
    InputAcessorDirective,
    TextareaAcessorDirective,
    InterpolateStringPipe,
    CookieDialogComponent,
    FocusOnNextFormElement,
    CustomPromoTagComponent,
    UnhDialogRefDirective,
    CustomCropperButton,
    ModalxContainerComponent,
    BackgroundfyPipe,
    TransformImagePipe,
    ConfirmDefaultComponent,
    EllipsisPipe,
    FilterBottomsheetOptionListComponent,
    ProjectListComponent,
    FilterBottomsheetHeaderComponent,
    FilterBottomsheetComponent,
    CoursesNotFoundComponent,
    BannerBirthdayComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    PerfectScrollbarModule,
    ImageCropperModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
    MatProgressSpinnerModule,
    PaymentModule,
    NgxMaskModule.forRoot(maskConfig),
    GenericComponentsModule,
    QuillModule.forRoot(),
    EmbedVideo.forRoot(),
    DragDropModule,
    MediaUploaderModule,
    InViewportModule,
    UserAvatarModule,
  ],
  exports: [
    CommonModule,
    MaterialModule,
    PerfectScrollbarModule,
    ImageCropperModule,
    SwiperModule,
    MatProgressSpinnerModule,
    ButtonContainerComponent,
    MainNavContainerComponent,
    NavItemDividerComponent,
    SvgIconComponent,
    SpinnerLoaderComponent,
    SimpleTabsComponent,
    SimpleTabsTabComponent,
    VideoBoxComponent,
    BannerHighlightComponent,
    BannersHomeComponent,
    BannerProComponent,
    BannerDefaultComponent,
    BannersPromoComponent,
    ButtonComponent,
    StudentsPortfolioComponent,
    DropdownListComponent,
    DropdownListItemComponent,
    ListItemComponent,
    SearchInputComponent,
    InputGroupComponent,
    DropdownButtonComponent,
    ModalComponent,
    GenericRowContainerComponent,
    GenericGalleryComponent,
    GenericGalleryAdminToolbarComponent,
    GenericGalleryItemComponent,
    SimpleGalleryItemComponent,
    QuickActionsContainerComponent,
    QuickActionsItemComponent,
    ImageCropperContainerComponent,
    DateFnsFormatPipe,
    DateFnsFormatTimePipe,
    StripHtmlPipe,
    IfMediaDirective,
    ImgLoadedDirective,
    ObserveOffsetBottomDirective,
    DownloadResourceDirective,
    HoverObserverDirective,
    GalleryItemCropDialog,
    RetryPaymentDialog,
    AddClassOnClickDirective,
    MenuStateObserverDirective,
    ProjectHighlightComponent,
    ProjectItemComponent,
    UserActionsComponent,
    QuillContentRendererComponent,
    SumPropertyPipe,
    CompareDatePipe,
    DateAgoPipe,
    GenericSwiperSliderComponent,
    BounceOnClickDirective,
    AnimatedLikeButtonComponent,
    GenericContentContainerComponent,
    SlotLeftComponent,
    SlotMiddleComponent,
    SlotRightComponent,
    PriceBoxComponent,
    PriceBoxSimpleComponent,
    PriceBoxBordlessComponent,
    PriceBoxTeamComponent,
    TestimonialBoxComponent,
    RatingComponent,
    CompareGridComponent,
    StickyItemDirective,
    FaqComponent,
    PriceWithDiscountComponent,
    PaymentProfileCardComponent,
    SimpleCardComponent,
    SocialMenuComponent,
    MosaicoItemComponent,
    MosaicoProjetosComponent,
    MosaicoItemSquareComponent,
    MosaicoItemSuperTrunfoComponent,
    DepoimentosItemComponent,
    DepoimentosContainerComponent,
    SliderVideosComponent,
    CommaJoinedTagsComponent,
    SpinnerProgressComponent,
    ArrayJoinPipe,
    KeysMapperPipe,
    IsProductOwnedPipe,
    FormCreditCardComponent,
    BenefitsPanelComponent,
    ResponsiveVideoComponent,
    SectionTitleComponent,
    FilterProjectGridComponent,
    FilterProjectGridItemComponent,
    GenericComponentsModule,
    MediaUploaderModule,
    CommentItemComponent,
    CommentBoxReplyComponent,
    LoaderPackComponent,
    SlugifyPipe,
    ParseJsonPipe,
    SafeImage,
    DialogNavigationComponent,
    ClickedOutDirective,
    BlocksControlsContainerComponent,
    ClearPasteFormatingDirective,
    OldPriceTagComponent,
    CommentsContainerComponent,
    CommentQuillEditorComponent,
    PostBadgesListComponent,
    InViewportModule,
    DropdownComponent,
    EventOnChildrenDirective,
    CustomToolbarComponent,
    FakeProjectPostItem,
    InputAcessorDirective,
    TextareaAcessorDirective,
    InterpolateStringPipe,
    FocusOnNextFormElement,
    CustomPromoTagComponent,
    UnhDialogRefDirective,
    CustomCropperButton,
    BackgroundfyPipe,
    TransformImagePipe,
    DragDropModule,
    EllipsisPipe,
    FilterBottomsheetOptionListComponent,
    ProjectListComponent,
    FilterBottomsheetHeaderComponent,
    FilterBottomsheetComponent,
    CoursesNotFoundComponent,
    BannerBirthdayComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
